// Shared currency catalog for the whole app (matches backend routers/currencies.py).
// Rate model: rates[X] = value of 1 unit of X expressed in the company BASE currency.
export const CURRENCY_CATALOG = [
  { code: "SYP", name: "الليرة السورية", flag: "SY" },
  { code: "TRY", name: "الليرة التركية", flag: "🇹🇷" },
  { code: "USD", name: "الدولار الأمريكي", flag: "🇺🇸" },
  { code: "EUR", name: "اليورو", flag: "🇪🇺" },
  { code: "SAR", name: "الريال السعودي", flag: "🇸🇦" },
  { code: "AED", name: "الدرهم الإماراتي", flag: "🇦🇪" },
  { code: "KWD", name: "الدينار الكويتي", flag: "🇰🇼" },
  { code: "QAR", name: "الريال القطري", flag: "🇶🇦" },
  { code: "BHD", name: "الدينار البحريني", flag: "🇧🇭" },
  { code: "OMR", name: "الريال العُماني", flag: "🇴🇲" },
  { code: "EGP", name: "الجنيه المصري", flag: "🇪🇬" },
  { code: "JOD", name: "الدينار الأردني", flag: "🇯🇴" },
  { code: "LBP", name: "الليرة اللبنانية", flag: "🇱🇧" },
  { code: "IQD", name: "الدينار العراقي", flag: "🇮🇶" },
  { code: "YER", name: "الريال اليمني", flag: "🇾🇪" },
  { code: "LYD", name: "الدينار الليبي", flag: "🇱🇾" },
  { code: "MAD", name: "الدرهم المغربي", flag: "🇲🇦" },
  { code: "TND", name: "الدينار التونسي", flag: "🇹🇳" },
  { code: "DZD", name: "الدينار الجزائري", flag: "🇩🇿" },
  { code: "SDG", name: "الجنيه السوداني", flag: "🇸🇩" },
  { code: "GBP", name: "الجنيه الإسترليني", flag: "🇬🇧" },
  { code: "CHF", name: "الفرنك السويسري", flag: "🇨🇭" },
  { code: "CAD", name: "الدولار الكندي", flag: "🇨🇦" },
  { code: "AUD", name: "الدولار الأسترالي", flag: "🇦🇺" },
  { code: "JPY", name: "الين الياباني", flag: "🇯🇵" },
  { code: "CNY", name: "اليوان الصيني", flag: "🇨🇳" },
  { code: "RUB", name: "الروبل الروسي", flag: "🇷🇺" },
  { code: "INR", name: "الروبية الهندية", flag: "🇮🇳" },
  { code: "SEK", name: "الكرونة السويدية", flag: "🇸🇪" },
  { code: "NOK", name: "الكرونة النرويجية", flag: "🇳🇴" },
  { code: "DKK", name: "الكرونة الدنماركية", flag: "🇩🇰" },
];

export const CURRENCY_MAP = Object.fromEntries(CURRENCY_CATALOG.map((c) => [c.code, c]));
export const CURRENCY_CODES = CURRENCY_CATALOG.map((c) => c.code);
// The currencies a company actually trades in = its base + the extra ones enabled at setup.
export const companyCurrencies = (company) => {
  const set = new Set();
  if (company?.base_currency) set.add(company.base_currency);
  (company?.enabled_currencies || []).forEach((c) => c && set.add(c));
  if (!set.size) set.add("SYP");
  return Array.from(set);
};
export const currencyName = (code) => CURRENCY_MAP[code]?.name || code;
export const currencyFlag = (code) => CURRENCY_MAP[code]?.flag || "🏳️";
